import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import './Header.scss';

const NAVS = [
  { path: '/', label: '首页' },
  { path: '/about', label: '关于我们' },
  { path: '/services', label: '产品服务' },
  { path: '/contact', label: '联系我们' },
];

function Header() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  // 登录后在「联系我们」之后追加「会员中心」入口
  const navs = user
    ? [...NAVS, { path: '/account', label: '会员中心' }]
    : NAVS;

  return (
    <header className="site-header">
      <div className="container header-inner">
        <NavLink to="/" className="logo">
          <img src="/logo.png" alt="好美意" className="logo-img" />
          <span className="logo-text">
            好美意
          </span>
        </NavLink>
        <nav className="nav">
          {navs.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              end={item.path === '/'}
              className={({ isActive }) =>
                isActive ? 'nav-link active' : 'nav-link'
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>
        <div className="header-actions">
          {user ? (
            <div className="user-box">
              <span className="user-name">👤 {user.name}</span>
              <button className="btn-logout" onClick={logout}>
                退出
              </button>
            </div>
          ) : (
            <>
              <a href="tel:4008886666" className="header-phone">
                021-64157750
              </a>
              <button className="btn-login" onClick={() => navigate('/login')}>
                登录
              </button>
            </>
          )}
        </div>
      </div>
    </header>
  );
}

export default Header;
